/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Phase_ReadyInputs */

const en_welcome_phase_ready = /** @type {(inputs: Welcome_Phase_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready`)
};

const fr_welcome_phase_ready = /** @type {(inputs: Welcome_Phase_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prêt`)
};

const ms_sg2_welcome_phase_ready = /** @type {(inputs: Welcome_Phase_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedia`)
};

/**
* | output |
* | --- |
* | "Ready" |
*
* @param {Welcome_Phase_ReadyInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const welcome_phase_ready = /** @type {((inputs?: Welcome_Phase_ReadyInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Phase_ReadyInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_welcome_phase_ready(inputs)
	if (locale === "fr") return fr_welcome_phase_ready(inputs)
	return ms_sg2_welcome_phase_ready(inputs)
});